module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_4.ec22d0b8.png";